/** Does an actions object contain an action with matching type?
 * @param actions Actions object following the project convention we use for our ducks,
 *                e.g. { shortKeyName1:prefixedKeyName1, shortKeyName2:prefixedKeyName2 }
 * @param actionType  The fully prefixed action type name.
 */
export const hasAction = (actions, actionType) => Object.values(actions).includes(actionType);
